<ng-template #modalContent>
  <form class="address-add-modal" [formGroup]="form" (ngSubmit)="onSubmit()">
    <udex-message-strip
      *ngIf="error"
      design="Negative"
      status-type="None"
      hide-close-button
      class="udex-my-20"
      data-cy="error-message"
    >
      <div class="d-flex justify-content-center udex-ps-16 udex-py-16">
        <h3 class="header__medium--m">
          {{ 'common.errors.somethingWrong' | cxTranslate }}
        </h3>
      </div>
      <div class="d-flex">
        <p class="text-center udex-mb-20" *ngIf="error?.status">
          {{
            ((error.status === 400) ? 'checkout.digitalNativeCheckout.newPrimaryAccessLocation.errors.validation' :
              'checkout.digitalNativeCheckout.newPrimaryAccessLocation.errors.generic') | cxTranslate
          }}
        </p>
      </div>
    </udex-message-strip>

    <div class="d-flex flex-column">
      <div *ngIf="country">
        <div class="d-flex flex-nowrap justify-content-start align-items-center">
          <div class="ds-flag-wrapper udex-me-4">
            <span class="flag ds-flag--{{country?.isocode.toLowerCase()}}"></span>
          </div>
          <span data-cy="country">{{ country?.name }}</span>
        </div>

        <div class="udex-pt-20 udex-pt-sm-24 udex-mb-20 udex-mb-sm-24" data-cy="company-name">
          <span>{{ user?.orgUnit?.name }}</span>
        </div>
      </div>
      <div class="address-add-modal__street">
        <udex-text-field
          required
          #streetAddress
          tooltip-placement="bottom-end"
          class="udex-pt-8"
          [value]="getFormControl('street').value"
          [label]="'registration.label.street' | cxTranslate"
          [supportingText]="isMaxLengthError('street') ? (getErrorMessage('street') | cxTranslate: { maxLength: getMaxLength('street') }) : (getErrorMessage('street') | cxTranslate)"
          [valueState]="getErrorStatus('street')"
          (input)="onInputChange($event, 'street')"
        ></udex-text-field>
        <dcp-icon-button-tooltip class="address-add-modal__tooltip" placement="Bottom" [openOnClick]="true">
          <div
            class="address-add-modal__tooltip-content body--s">{{ 'checkout.digitalNativeCheckout.newPrimaryAccessLocation.tooltip.address' | cxTranslate }}
          </div>
        </dcp-icon-button-tooltip>
      </div>
      <udex-text-field
        class="udex-pt-sm-24 udex-pt-20"
        [value]="getFormControl('line2').value"
        [label]="'registration.label.addressLine2' | cxTranslate"
        [supportingText]="isMaxLengthError('line2') ? (getErrorMessage('line2') | cxTranslate: { maxLength: getMaxLength('line2') }) : (getErrorMessage('line2') | cxTranslate)"
        [valueState]="getErrorStatus('line2')"
        (input)="onInputChange($event, 'line2')"
      ></udex-text-field>
      <udex-text-field
        required
        class="udex-pt-sm-24 udex-pt-20"
        [value]="getFormControl('city').value"
        [label]="'registration.label.city' | cxTranslate"
        [supportingText]="isMaxLengthError('city') ? (getErrorMessage('city') | cxTranslate: { maxLength: getMaxLength('city') }) : (getErrorMessage('city') | cxTranslate)"
        [valueState]="getErrorStatus('city')"
        (input)="onInputChange($event, 'city')"
      ></udex-text-field>
      <div class="address-add-modal__last-row d-flex justify-content-between">
        <udex-select-box
          *ngIf="isRequired(getFormControl('regionCode'))"
          (selection-change)="onSelect($event)"
          #regionDropdown
          class="medium udex-pt-sm-24 udex-pt-20"
          [label]="'registration.label.regionCode' | cxTranslate"
          [supportingText]="isMaxLengthError('regionCode') ? (getErrorMessage('regionCode') | cxTranslate: { maxLength: getMaxLength('regionCode') }) : (getErrorMessage('regionCode') | cxTranslate)"
          [valueState]="getErrorStatus('regionCode')"
          disable-target-overlap
        >
          <udex-select-box-item
            *ngFor="let region of regions; trackBy: trackByRegion"
            [label]="region.name"
            [value]="region.isocode"
            [selected]="getFormControl('regionCode') === region.isocode"
          >
          </udex-select-box-item>
        </udex-select-box>
        <udex-text-field
          required
          [ngClass]="{ 'medium': isRequired(getFormControl('regionCode')), 'large': !isRequired(getFormControl('regionCode')) }"
          class="udex-pt-sm-24 udex-pt-20"
          [value]="getFormControl('postalCode').value"
          [label]="'registration.label.postalCode' | cxTranslate"
          [supportingText]="isMaxLengthError('postalCode') ? (getErrorMessage('postalCode') | cxTranslate: { maxLength: getMaxLength('postalCode') }) : (getErrorMessage('postalCode') | cxTranslate)"
          [valueState]="getErrorStatus('postalCode')"
          (input)="onInputChange($event, 'postalCode')"
        ></udex-text-field>
      </div>
    </div>

    <div class="d-flex justify-content-start udex-mt-32">
      <udex-button
        class="udex-me-12 focusable focusable__element"
        design="Primary"
        size="Large"
        data-cy="submit-btn"
        [disabled]="inProgress || (newAddressCreated | async)"
        (click)="onSubmit()"
      >
        <span
          *ngIf="!inProgress; else showSpinner">{{ createButtonText }}</span>
        <ng-template #showSpinner>
          <span>
          <ui5-busy-indicator
            size="Medium"
            class="white-dots d-flex"
            active></ui5-busy-indicator>
        </span>
        </ng-template>
      </udex-button>
      <udex-button
        class="udex-me-12 focusable focusable__element"
        design="Secondary"
        size="Large"
        data-cy="cancel-new-address-btn"
        [disabled]="inProgress || (newAddressCreated | async)"
        (click)="closeModal()"
      >
        {{ 'common.cancel' | cxTranslate }}
      </udex-button>
    </div>
  </form>
</ng-template>
